/* eslint-disable no-nested-ternary */
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import CollectionContainer from './CollectionContainer';
import CategoryCard from './CategoryCard';
import Theme from '../../ui/Theme';
import CustomTabPanel from './CustomTabPanel';
import ZeroState from '../../common/ZeroState';
import FileIcon from '../../../assets/FileIcon';
import { ReactComponent as EmptySearchFolder } from '../../../assets/EmptySearchFolder.svg';
import BasicZeroState from '../../common/BasicZeroState';
import HandleCollectionCheckin from '../../collections/HandleCollectionCheckin';

const useStyles = makeStyles({
  root: {
    textTransform: 'none',
  },
  tabs: {
    '& .MuiTabs-indicator': {
      backgroundColor: Theme.palette.primary.main,
    },
    '& .MuiTab-root.Mui-selected': {
      color: Theme.palette.primary.main,
      fontFamily: 'Lato',
      fontWeight: '700',
      fontSize: '14px',
      textTransform: 'none',
    },
    '& .MuiTab-root': {
      color: '#1D2939',
      fontFamily: 'Lato',
      fontWeight: '700',
      fontSize: '14px',
      textTransform: 'none',
    },
  },
});

const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

export default function DepartmentTabs({ value, setValue, searchVal, setOpen }) {
  const classes = useStyles();

  const depts = useSelector((state) => state.categoryData.selectedCategoryDeptCollections).departments;
  const selectedPartnerId = useSelector((state) => state.categoryData.selectedId);
  const [filteredCollection, setFilteredCollection] = React.useState([]);
  const [openAddPopup, setOpenAddPopup] = React.useState(false);
  const [colId, setColId] = React.useState(null);
  React.useEffect(() => {
    setValue(0);
  }, [selectedPartnerId]);

  React.useEffect(() => {
    if (!searchVal) {
      setFilteredCollection([]);
      return;
    }

    const matchedCollections = depts.reduce((acc, dept) => {
      dept.categories?.forEach((cat) => {
        const filteredItems = cat.collections?.filter((col) =>
          col.title?.toLowerCase().includes(searchVal.toLowerCase()),
        );

        if (filteredItems?.length > 0) {
          acc.push({
            categoryId: cat.id,
            categoryName: cat.name,
            collections: filteredItems,
          });
        }
      });
      return acc;
    }, []);

    setFilteredCollection(matchedCollections);
  }, [searchVal, depts]);

  const handleChange = (event, newValue) => setValue(newValue);
  const handleCreateOpen = () => setOpen(true);
  const handleClose = () => {
    setOpenAddPopup(false);
  };
  const handleOpen = (id) => {
    setOpenAddPopup(true);
    setColId(id);
  };
  const getCollectionCount = (dept) => {
    if (searchVal) {
      return (
        dept.categories?.reduce((acc, cat) => {
          const matchedCategory = filteredCollection.find((f) => f.categoryId === cat.id);
          return matchedCategory ? acc + matchedCategory.collections.length : acc;
        }, 0) || 0
      );
    }
    return dept.collectionCount;
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className={classes.tabs}>
          {depts?.map((dept, index) => {
            const collectionsCount = getCollectionCount(dept);
            return <Tab key={dept.id} label={`${dept.name} (${collectionsCount})`} {...a11yProps(index)} />;
          })}
        </Tabs>
      </Box>

      <Box sx={{ height: '550px', overflowY: 'auto', overflowX: 'hidden' }}>
        {depts?.map((dept, deptIndex) => (
          <CustomTabPanel key={dept.id} value={value} index={deptIndex}>
            {searchVal && filteredCollection.length === 0 ? (
              <ZeroState
                Icon={EmptySearchFolder}
                title="No Search Results found."
                style={{ paddingBottom: '100px', marginTop: '40px' }}
                cardWidth="600px"
              />
            ) : dept.categories && dept.categories.length > 0 ? (
              dept.categories.map((cat, catIndex) => (
                <Box key={cat.id}>
                  <>
                    {cat?.id && (
                      <CategoryCard
                        categoryId={cat.id}
                        categoryName={cat.name}
                        title={cat.name}
                        ind={catIndex + 1}
                        deptId={dept?.id}
                        value={value}
                        deptName={dept?.name}
                        collections={cat.collections}
                      />
                    )}

                    {dept?.id === null && cat.collections && cat.collections.length === 0 ? (
                      <ZeroState
                        Icon={FileIcon}
                        title="No Collections without a category"
                        style={{ paddingBottom: '100px', marginTop: '40px' }}
                        cardWidth="600px"
                      />
                    ) : cat.collections && cat.collections.length > 0 ? (
                      <CollectionContainer
                        categoryId={cat.id}
                        handleOpen={handleOpen}
                        handleClose={handleClose}
                        openAddPopup={openAddPopup}
                        searchValue={searchVal}
                      />
                    ) : (
                      <BasicZeroState text="No collections present in this category." />
                    )}
                    {openAddPopup && (
                      <HandleCollectionCheckin open close={handleClose} mode="edit" id={colId} fromCat />
                    )}
                  </>
                </Box>
              ))
            ) : (
              <ZeroState
                Icon={FileIcon}
                title="No Collection Category added."
                text="Add a category first to start adding your collections."
                style={{ paddingBottom: '100px', marginTop: '40px' }}
                cardWidth="600px"
                btnText="Add Category"
                btnAction={handleCreateOpen}
              />
            )}
          </CustomTabPanel>
        ))}
      </Box>
    </Box>
  );
}
